import React from "react";
import { ErrorMessage } from 'formik';

export const FieldError = ({ name, style }) => (
    <ErrorMessage name={name}>
        {msg =>
            msg ? (
                <div className="field-error" style={{ color: 'red', marginTop: 4, ...style }}>
                    {msg}
                </div>
            ) : null
        }
    </ErrorMessage>
);
